import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { MessageService } from './message.service';
import { Template } from '../models/Template';

@Injectable({ providedIn: 'root' })

export class TemplateService { 
  private _ENDPOINT: string = '';

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient,
    private messageService: MessageService, @Inject('BASE_URL') baseUrl) {
    this._ENDPOINT = baseUrl + 'api/templates';   
  }
 
  getAll(): Observable<Array<Template>> { 
    return this.http.get<Array<Template>>(this._ENDPOINT + '');
  }
  
  getById(id: any): Observable<Template> {
    const url = this._ENDPOINT+'/'+id;
    return this.http.get<Template>(url);
  }

  /** POST: add a new template to the server */
  add(template: Template): Observable<Template> {
    return this.http.post<Template>(this._ENDPOINT, template, this.httpOptions).pipe(
      tap((newTemplate: Template) => this.log('added template w/ id=${newTemplate.id}')),
      catchError(this.handleError<Template>('add'))
    );
  }

  /** DELETE: delete the template from the server */
  delete(id: number): Observable<Template> {
    const url = this._ENDPOINT + '/' + id;

    return this.http.delete<Template>(url, this.httpOptions).pipe(
      tap(_ => this.log('deleted template id=${id}')),
      catchError(this.handleError<Template>('delete'))
    );
  }

  /** PUT: update the template on the server */
  update(id: number, template: Template): Observable<any> {
    return this.http.put(this._ENDPOINT + "/" + id, template , this.httpOptions).pipe(
      tap(_ => this.log('updated template id=${template.Id}')),
      catchError(this.handleError<any>('update'))
    );
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log('${operation} failed: ${error.message}');

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a TemplateService message with the MessageService */
  private log(message: string) {
    this.messageService.add('TemplateService: ${message}');
  }
}
